export const surveyQuestionsApiUrl = 'survey-questions';
export const surveyQuestionOptionsApiUrl = 'question-options';
export const surveyQuestionAssetsApiUrl = 'question-assets';
export const surveyQuestionOptionAssetsApiUrl = 'option-assets';
export const surveySectionOptionAssetsApiUrl = 'section';
export const surveySectionDeletesApiUrl = 'delete-section';
export const surveyQuestionBulkOptionsApiUrl = 'question-options/bulkCreate';
export const surveyMatrixQuestionCustomRowColumns = 'question-options/customRowColumns';
export const surveyBulkQuestionApiUrl = 'questionnaires/textListToQuestionnaire';
